import { fetchWrapper } from "../../utils/request";
import { endpoint } from "./endpoint";

export async function getPayments() {
  return fetchWrapper(endpoint + `/v1/payments`, {
    method: "get",
  }).then((res) => res.json());
}
